import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import { createBrowserHistory as createHistory } from "history";

import { loadState, saveState } from "./sessionStorage";
import rootReducers from "./rootReducers";

export const history = createHistory();

const persistedState = loadState();
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = createStore(
  rootReducers,
  persistedState,
  composedEnhancers
);

// ========================================================
// Persist data on page refresh
// ========================================================
store.subscribe(() => {
  saveState(store.getState());
});

export default store;
